import React, { FC, useCallback } from 'react';
import Card from 'src/components/Card';
import { Grid, Table, TableBody, TableHead, TableRow } from '@material-ui/core';
import TableCell from 'src/components/TableCell';
import DateRangeInput from 'src/components/DateRangeInput';
import Rating from '@material-ui/lab/Rating';
import EmployeeCell from 'src/scenes/Rankings/components/EmployeeCell';

interface Props {
  employeesStats: Record<string, { ticketCount: number; averageRating: number }>;
  startDateFilter?: string;
  endDateFilter?: string;
  onChangeDateFilter: (startDate?: string, endDate?: string) => void;
}

const CustomerRatingRanking: FC<Props> = ({ employeesStats, onChangeDateFilter, startDateFilter, endDateFilter }) => {
  const sortEmployees = useCallback(() => {
    const employees: { ticketCount: number; averageRating: number; employeeId: string }[] = Object.keys(
      employeesStats
    ).map((employeeId) => ({
      employeeId,
      ...employeesStats[employeeId],
    }));

    const poidsMoyenne = 0.7;
    const poidsNotes = 0.3;

    return employees.sort((a, b) => {
      const scoreA = a.averageRating * poidsMoyenne + a.ticketCount * poidsNotes;
      const scoreB = b.averageRating * poidsMoyenne + b.ticketCount * poidsNotes;

      return scoreB - scoreA;
    });
  }, [employeesStats]);

  return (
    <Grid style={{ marginTop: 30 }} container justifyContent='center'>
      <Grid item xs={11}>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={10}>
            <Card>
              <Grid container spacing={3}>
                <Grid item xs={12} lg={10}>
                  <DateRangeInput startDate={startDateFilter} endDate={endDateFilter} onChange={onChangeDateFilter} />
                </Grid>

                <Grid item xs={12} style={{ overflowX: 'auto' }}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Employé</TableCell>
                        <TableCell align='center'>Nb. Avis</TableCell>
                        <TableCell align='right'>Moyenne</TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {Object.keys(employeesStats).length === 0 && (
                        <TableRow>
                          <TableCell colSpan={3}>Aucun résultat</TableCell>
                        </TableRow>
                      )}

                      {sortEmployees().map((employeeStat, key) => (
                        <TableRow key={employeeStat.employeeId}>
                          <EmployeeCell position={key + 1} employeeId={employeeStat.employeeId} />
                          <TableCell align='center'>{employeeStat.ticketCount}</TableCell>
                          <TableCell align='right'>
                            <Rating size='small' value={employeeStat.averageRating} precision={0.1} max={4} readOnly />
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Grid>
              </Grid>
            </Card>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default CustomerRatingRanking;
